export default {
  schoolVacancies: 'schoolVacancies',
  schoolVacancyApplications: 'schoolVacancyApplications',
  candidateApplications: 'candidateApplications',
  schoolVacancyPriorCandidates: 'schoolVacancyPriorCandidates',
  adminUsers: 'adminUsers',
  adminAudit: 'adminAudit'
};


// WEBPACK FOOTER //
// ./src/constants/list-names.js